/// <amd-module name="Environments/EnvironmentTraceabilityChanges/Common/CommitViewService" />
import { ICommitViewChangesData, ICommitViewService } from "Environments/EnvironmentTraceabilityChanges/Common/CommitViewService.types";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Change, IArtifactDetails, IDataResult } from "Traceability/Changes/Types";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { Utilities } from "Traceability/Common/Utilities";

const commitsDataProviderId = "ms.vss-environments-web.environment-traceability-commits-data-provider";

export class CommitViewService extends VssService implements ICommitViewService {
    private _contributionService: IVssContributionService;
    private _data: ICommitViewChangesData;
    public get pageData(): ICommitViewChangesData{
        return this._data;
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._initialize();
    }

    public _serviceEnd(pageContext: IVssPageContext): any {
        super._serviceEnd(pageContext);
    }

    public getChanges = (artifactDetails: IArtifactDetails): Promise<IDataResult<Change>>  => {
        return Promise.resolve({} as IDataResult<Change>);
    }

    private _initialize() {
        let syncData = this._contributionService.getData<ICommitViewChangesData>(commitsDataProviderId);
        if(!syncData) {
            this._updateChangesTab();
        } else {
            let pageData: ICommitViewChangesData = syncData as  ICommitViewChangesData;
            if (!!pageData.primaryArtifactAlias) {
                // order by primaryArtifactAlias and then other artifacts
                (pageData.artifactsData || []).sort((a, b) => localeIgnoreCaseComparer(pageData.primaryArtifactAlias, a && a.artifactVersion && a.artifactVersion.alias) === 0 ? -1 : 1);
            }
            // fill the artifact url for 'view details'
            pageData.artifactsData = Utilities.fillArtifactVersionDisplayUri<Change>(this.pageContext, pageData.artifactsData);
            Utilities.setPrimaryArtifactAliasName(pageData.primaryArtifactAlias);
    
            this._data = pageData;  
        }     
    }

    private _updateChangesTab = async (): Promise<void> => {
        const pageData = await (this._contributionService.getDataAsync<ICommitViewChangesData>(commitsDataProviderId, undefined, true) || {}) as ICommitViewChangesData;
        if (!!pageData.primaryArtifactAlias) {
            // order by primaryArtifactAlias and then other artifacts
            (pageData.artifactsData || []).sort((a, b) => localeIgnoreCaseComparer(pageData.primaryArtifactAlias, a && a.artifactVersion && a.artifactVersion.alias) === 0 ? -1 : 1);
        }
        // fill the artifact url for 'view details'
        pageData.artifactsData = Utilities.fillArtifactVersionDisplayUri<Change>(this.pageContext, pageData.artifactsData);
        Utilities.setPrimaryArtifactAliasName(pageData.primaryArtifactAlias);

        this._data = pageData; 
    }
    
}

Services.add("ICommitViewChangesService", { serviceFactory: CommitViewService });
